import { api } from './base';

import { UserGuideType } from 'v2/constants';
import { MutationArg, Pageable } from 'v2/types';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';
import { UserGuideModel, UserGuideStatistic } from 'v2/types/UserGuideModel';

export const userGuideService = {
  getGuides([_key, page, limit]: SWRKeyPagination): Promise<Pageable<UserGuideModel>> {
    return api
      .get('v1/admin/user-guide', { searchParams: { page, limit, sortFields: JSON.stringify({ _id: 'asc' }) } })
      .json();
  },

  createGuide(_key: string, { arg }: MutationArg<Omit<UserGuideModel, 'id'>>): Promise<UserGuideModel> {
    return api.post('v1/admin/user-guide', { json: arg }).json();
  },

  updateGuide([_key, guideId]: SWRKeyValue, { arg }: MutationArg<Omit<UserGuideModel, 'id'>>): Promise<UserGuideModel> {
    return api.put(`v1/admin/user-guide/${guideId}`, { json: arg }).json();
  },

  deleteGuide([_key, guideId]: SWRKeyValue): Promise<UserGuideModel> {
    return api.delete(`v1/admin/user-guide/${guideId}`).json();
  },

  markGuideAsDefault([_key, guideId]: SWRKeyValue): Promise<UserGuideModel> {
    return api.patch(`v1/admin/user-guide/${guideId}/default`).json();
  },

  getGuidesStatistics(
    _key: string,
    { arg }: MutationArg<{ guideType: UserGuideType; startDate: string; endDate: string }>
  ): Promise<UserGuideStatistic[]> {
    return api
      .get(`v1/admin/user-guide/${arg.guideType}/statistics`, {
        searchParams: { startDate: arg.startDate, endDate: arg.endDate },
        timeout: 300_000,
      })
      .json();
  },
};
